import { Action } from '@ngrx/store';
import { Application } from '../../../models/application.model';

export enum ActionType {

  ADD_APPLICATION = 'ADD_APPLICATION',
  ADD_APPLICATION_SUCCESS = 'ADD_APPLICATION SUCCESS',
  ADD_APPLICATION_FAILED = 'ADD_APPLICATION FAILED',
  DELETE_APPLICATION = 'DELETE_APPLICATION',
  DELETE_APPLICATION_SUCCESS = 'DELETE_APPLICATION SUCCESS',
  DELETE_APPLICATION_FAILED = 'DELETE_APPLICATION FAILED',
  FETCH_APPLICATIONS_BY_COMPANYID = 'FETCH APPLICATIONS BY COMPANY ID',
  FETCH_APPLICATIONS_BY_COMPANYID_SUCCESS = 'FETCH APPLICATIONS BY COMPANY ID SUCCESS',
  FETCH_APPLICATIONS_BY_COMPANYID_FAILED = 'FETCH APPLICATIONS BY COMPANY ID FAILED',
  FETCH_APPLICATIONS = 'FETCH APPLICATIONS',
  FETCH_APPLICATIONS_SUCCESS = 'FETCH APPLICATIONS SUCCESS',
  FETCH_APPLICATIONS_FAILED = 'FETCH APPLICATIONS FAILED',
  UPDATE_APPLICATION = 'UPDATE APPLICATION',
  UPDATE_APPLICATION_SUCCESS = 'UPDATE APPLICATION SUCCESS',
  UPDATE_APPLICATION_FAILED = 'UPDATE APPLICATION FAILED',
  DESTROY_APPLICATION = 'DESTROY_APPLICATION',
  DESTROY_APPLICATION_SUCCESS = 'DESTROY_APPLICATION SUCCESS',
  DESTROY_APPLICATION_FAILED = 'DESTROY_APPLICATION FAILED',
  FETCH_APPLICATIONS_BY_COMPANYIDSITEID = 'FETCH APPLICATIONS BY COMPANYIDSITEID',
  FETCH_APPLICATIONS_BY_COMPANYIDSITEID_SUCCESS = 'FETCH APPLICATIONS BY COMPANYIDSITEID SUCCESS',
  FETCH_APPLICATIONS_BY_COMPANYIDSITEID_FAILED = 'FETCH APPLICATIONS BY COMPANYIDSITEID FAILED',
  FETCH_APPLICATIONS_BY_APPID = 'FETCH APPLICATIONS BY APP ID',
  FETCH_APPLICATIONS_BY_APPID_SUCCESS = 'FETCH APPLICATIONS BY APP ID SUCCESS',
  FETCH_APPLICATIONS_BY_APPID_FAILED = 'FETCH APPLICATIONS BY APP ID FAILED',
}

export class FetchApplicationsByAppId implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_APPID;
  constructor(public appId: string) { }
}

export class FetchApplicationsByAppIdSuccess implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_APPID_SUCCESS;
  constructor(public applications: Application[]) { }
}

export class FetchApplicationsByAppIdFailed implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_APPID_FAILED;
  constructor(public error: any) { }
}

export class DestroyApplication implements Action {
  readonly type = ActionType.DESTROY_APPLICATION;

  constructor(public id: string ) { }
}

export class DestroyApplicationSuccess implements Action {
  readonly type = ActionType.DESTROY_APPLICATION_SUCCESS;

  constructor(public id: string) { }
}

export class DestroyApplicationFailed implements Action {
  readonly type = ActionType.DESTROY_APPLICATION_FAILED;

  constructor() { }
}

export class FetchApplications implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS;
  constructor() { }
}

export class FetchApplicationsSuccess implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_SUCCESS;
  constructor(public applications: Application[]) { }
}

export class FetchApplicationsFailed implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_FAILED;
  constructor(public error: any) { }
}


export class FetchApplicationsByCompanyId implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchApplicationsByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYID_SUCCESS;
  constructor(public applications: Application[]) { }
}

export class FetchApplicationsByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class FetchApplicationsByCompanyIdSiteId implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYIDSITEID;
  constructor(public companyId: string, public siteId: string) { }
}

export class FetchApplicationsByCompanyIdSiteIdSuccess implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYIDSITEID_SUCCESS;
  constructor(public applications: Application[]) { }
}

export class FetchApplicationsByCompanyIdSiteIdFailed implements Action {
  readonly type = ActionType.FETCH_APPLICATIONS_BY_COMPANYIDSITEID_FAILED;
  constructor(public error: any) { }
}

export class AddApplication implements Action {
  readonly type = ActionType.ADD_APPLICATION;

  constructor(public application: Application ) {  console.log('application', application); }
}

export class AddApplicationSuccess implements Action {
  readonly type = ActionType.ADD_APPLICATION_SUCCESS;

  constructor(public  application: Application ) { }
}

export class AddApplicationFailed implements Action {
  readonly type = ActionType.ADD_APPLICATION_FAILED;

  constructor() { }
}

export class DeleteApplication implements Action {
  readonly type = ActionType.DELETE_APPLICATION;

  constructor(public id: string ) { }
}

export class DeleteApplicationSuccess implements Action {
  readonly type = ActionType.DELETE_APPLICATION_SUCCESS;

  constructor(public id: number) { }
}

export class DeleteApplicationFailed implements Action {
  readonly type = ActionType.DELETE_APPLICATION_FAILED;

  constructor() { }
}

export class UpdateApplication implements Action {
  readonly type = ActionType.UPDATE_APPLICATION;

  constructor(public application: Application ) { }
}

export class UpdateApplicationSuccess implements Action {
  readonly type = ActionType.UPDATE_APPLICATION_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<Application>,
  ) { console.log('changes' , changes); }
}

export class UpdateApplicationFailed implements Action {
  readonly type = ActionType.UPDATE_APPLICATION_FAILED;

  constructor() { }
}

export type ApplicationActions =
  AddApplication | AddApplicationFailed | AddApplicationSuccess |
  UpdateApplication | UpdateApplicationSuccess | UpdateApplicationFailed |
  DeleteApplication | DeleteApplicationSuccess | DeleteApplicationFailed |
  FetchApplications | FetchApplicationsSuccess | FetchApplicationsFailed |
  FetchApplicationsByCompanyIdSiteId | FetchApplicationsByCompanyIdSiteIdSuccess | FetchApplicationsByCompanyIdSiteIdFailed |
  FetchApplicationsByCompanyId | FetchApplicationsByCompanyIdSuccess | FetchApplicationsByCompanyIdFailed |
  FetchApplicationsByAppId | FetchApplicationsByAppIdSuccess | FetchApplicationsByAppIdFailed

  ;



